<header-web (dataEvent)='setLanguage($event)' [inicio]='true'></header-web>
<section class="container-fluid px-0 bg-hueso">
  <div class="w-100 bg-white">
    <div class="container">
      <div class="px-5 mt-md-5 mt-0">
        <h2 class="fw-bold text-center text-rojo title">Paquetes a tu medida</h2>
      </div>
      <div class="row box-icon mx-0">
        <div class="caja-ico col-md-6 col-lg-3">
          <div class="face face1">
            <div class="content">
              <div class="icon">
                <img src="../../assets/image/recursos/D-Sotware.png" class="img-ico fas" alt="">
                <!-- <i class="fas fa-city" aria-hidden="true"></i> -->
              </div>
            </div>
          </div>
          <div class="face face2">
            <div class="content">
              <h3>
                <a class="fw-bold subtitle text-rojo" target="_blank">DESARROLLO DE SOFTWARE</a>
              </h3>
              <p class="text fw-bold text-negro lh-sm"><small>Software que se adapta a tu negocio, hecho a medida de tu
                  empresa.</small></p>
            </div>
          </div>
        </div>
        <div class="caja-ico col-md-6 col-lg-3">
          <div class="face face1">
            <div class="content">
              <div class="icon">
                <img src="../../assets/image/recursos/D-Web.png" class="img-ico fas" alt="">
                <!-- <i class="fas fa-city" aria-hidden="true"></i> -->
              </div>
            </div>
          </div>
          <div class="face face2">
            <div class="content">
              <h3>
                <a class="fw-bold subtitle text-rojo" target="_blank">DESARROLLO WEB</a>
              </h3>
              <p class="text fw-bold text-negro lh-sm"><small>Te presentamos una amplia variedad de plantillas basados
                  en WordPress o HTML5</small></p>
            </div>
          </div>
        </div>
        <div class="caja-ico col-md-6 col-lg-3">
          <div class="face face1">
            <div class="content">
              <div class="icon">
                <img src="../../assets/image/recursos/D-Hotel.png" class="img-ico fas" alt="">
                <!-- <i class="fas fa-city" aria-hidden="true"></i> -->
              </div>
            </div>
          </div>
          <div class="face face2">
            <div class="content">
              <h3>
                <a class="fw-bold subtitle text-rojo" target="_blank">SOFTWARE DE HOTELES </a>
              </h3>
              <p class="text fw-bold text-negro lh-sm"><small>Gestiona tus reservas, pagos, facturación y huéspedes
                  desde un solo sistema.</small></p>
            </div>
          </div>
        </div>
        <div class="caja-ico col-md-6 col-lg-3">
          <div class="face face1">
            <div class="content">
              <div class="icon">
                <img src="../../assets/image/recursos/D-Ecomerce.png" class="img-ico fas" alt="">
                <!-- <i class="fas fa-city" aria-hidden="true"></i> -->
              </div>
            </div>
          </div>
          <div class="face face2">
            <div class="content">
              <h3>
                <a class="fw-bold subtitle text-rojo" target="_blank">E-COMMERCE</a>
              </h3>
              <p class="text fw-bold text-negro lh-sm"><small>Recibe pagos desde tu página web.</small></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid p-md-5 p-0">
      <div class="w-100 my-3">
        <div class="row mx-0 d-flex align-items-center">
          <div class="col-md-5 order-1 order-lg-1 col-12 text-center">
            <img src="../../assets/image/galeria/foto-1.png" class="img-fluid" alt="">
          </div>
          <div class="col-md-7 order-2 order-lg-2 col-12">
            <div class="container py-3">
              <h2 class="text-center fw-bold title text-lago text-md-start">NOSOTROS SOMOS</h2>
              <p class="text fw-bold lh-sm text-justify d-none d-sm-block">Somos una empresa que tiene experiencia en el
                desarrollo de
                software, nuestro respaldo está en la formación profesional de nivel nacional e internacional de nuestro
                equipo de trabajo, conformado por Ingenieros de sistemas, asesores contables y tributarios, dicha
                experiencia ponemos a disposición de su empresa.</p>
              <p class="text fw-bold lh-sm text-justify">Nuestra Empresa <strong>“YACHAY APRODEC S.A.C”</strong>
                desarrolló el año 2017 el software de gestión empresarial y facturación electrónica “Galileo-ERP”, el
                cual es un producto altamente configurable, cuyo objetivo es cubrir las necesidades de todo tipo de
                Mypes,
                ofreciendo una solución económica, accesible al usuario y de fácil uso.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="row mx-0 d-flex justify-content-evenly mt-md-5 mt-1">
        <div class="col-lg-10 offset-lg-1 col-12 mt-md-5 mt-0">
          <div class="container text-center">
            <h2 class="lh-sm fw-bold title text-lago d-md-block d-none">Gestiona toda tu empresa de forma online cómo,
              cuando y desde
              donde quieras</h2>
            <h5 class="lh-sm fw-bold title text-justify text-lago d-md-none d-block">Gestiona toda tu empresa de forma
              online cómo, cuando y desde
              donde quieras</h5>
          </div>
        </div>
        <div class="w-100 mt-4"></div>
        <div class="col-lg-10 col-12 px-0">
          <div class="container-fluid">
            <div class="row mx-0">
              <div class="col-xl-2 col-lg-3 col-md-4 col-12 px-lg-3 px-md-1 px-0 text-center mx-auto">
                <div class="card border-0 bg-transparent">
                  <img src="../../assets/image/recursos/logo-1.png" class="card-img-top img-fluid" alt="...">
                  <div class="card-body text-center lh-sm px-0">
                    <h5 class="card-title mb-0 subtitle text-lago fw-bolder text-center lh-1">Accede desde donde sea</h5>
                    <p class="card-text lh-sm text-center mt-1 text fw-bold"><small>Función 100% en la nube, te permite
                        acceder desde cualquiera locación y dispositivo.</small></p>
                  </div>
                </div>
              </div>
              <div class="col-xl-2 col-lg-3 col-md-4 col-12 px-lg-3 px-md-1 px-0 text-center mx-auto">
                <div class="card border-0 bg-transparent">
                  <img src="../../assets/image/recursos/logo-2.png" class="card-img-top img-fluid" alt="...">
                  <div class="card-body text-center lh-sm px-0">
                    <h5 class="card-title mb-0 subtitle text-lago fw-bold lh-1">Rápido y fácil de usar</h5>
                    <p class="card-text lh-sm text-center mt-1 text fw-bold"><small>Configuración según las necesidades
                        de tu empresa en cuestión de minutos.</small></p>
                  </div>
                </div>
              </div>
              <div class="col-xl-2 col-lg-3 col-md-4 col-12 px-lg-3 px-md-1 px-0 text-center mx-auto">
                <div class="card border-0 bg-transparent">
                  <img src="../../assets/image/recursos/logo-3.png" class="card-img-top img-fluid" alt="...">
                  <div class="card-body text-center lh-sm px-0">
                    <h5 class="card-title mb-0 subtitle text-lago fw-bold lh-1">Crece con nosotros</h5>
                    <p class="card-text lh-sm text-center mt-1 text fw-bold"><small>Herramientas que te permiten tomar
                        las mejores decisiones para hacer crecer tu negocio.</small></p>
                  </div>
                </div>
              </div>
              <div class="col-xl-2 col-lg-3 col-md-4 col-12 px-lg-3 px-md-1 px-0 text-center mx-auto">
                <div class="card border-0 bg-transparent">
                  <img src="../../assets/image/recursos/logo-4.png" class="card-img-top img-fluid" alt="...">
                  <div class="card-body text-center lh-sm px-0">
                    <h5 class="card-title mb-0 subtitle text-lago fw-bold lh-1">Maxima seguridad</h5>
                    <p class="card-text lh-sm text-center mt-1 text fw-bold"><small>Tu información tratada de manera
                        muy segura, confidencialidad con nuestros clientes.</small></p>
                  </div>
                </div>
              </div>
              <div class="col-xl-2 col-lg-3 col-md-4 col-12 px-lg-3 px-md-1 px-0 text-center mx-auto">
                <div class="card border-0 bg-transparent">
                  <img src="../../assets/image/recursos/logo-5.png" class="card-img-top img-fluid" alt="...">
                  <div class="card-body text-center lh-sm px-0">
                    <h5 class="card-title mb-0 subtitle text-lago fw-bold lh-1">Instalación global</h5>
                    <p class="card-text lh-sm text-center mt-1 text fw-bold"><small>Nuestro equipo esta preparado para
                        ayudarte a implementar y usar el sistema desde cualquier lugar.</small></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <svg class="separator" width="100%" height="120" viewBox="0.1 0.1 180 40" preserveAspectRatio="none">
    <g transform="translate(-18.298844,-77.973964)">
      <path style="fill:#88c0a8;"
        d="M 31.615583,86.351641 H 192.16499 v 26.901969 c 0,0 -32.03411,-14.237983 -59.62682,-12.72484 -22.34188,1.2252 -54.779359,9.72634 -54.779359,9.72634 0,0 -22.029534,3.62882 -34.471238,-1.88988 -12.441702,-5.51871 -11.67199,-22.013589 -11.67199,-22.013589 z" />
      <path style="fill:#ffffff;"
        d="M 18.441597,78.106256 H 198.58126 v 39.288614 c 0,0 -43.10672,-27.825245 -73.47599,-19.687823 -30.369264,8.137423 -46.832208,12.548653 -46.832208,12.548653 0,0 -32.775418,8.05972 -46.735258,0 C 17.577964,102.19598 18.441597,78.106256 18.441597,78.106256 Z" />
    </g>
  </svg>
</section>
<section class="w-100">
  <div class="container-fluid p-md-5 p-1 bg-hueso">
    <div class="row">
      <div class="col-lg-10 offset-lg-1 col-12 px-0">
        <div class="d-flex align-items-center">
          <div class="nav flex-column nav-pills text-center mt-2 me-0 d-none d-sm-block" id="v-pills-tab" role="tablist"
            aria-orientation="vertical">
            <a class="nav-link active p-2 text-center" id="v-pills-point-tab" data-bs-toggle="pill"
              data-bs-target="#v-pills-point" type="button" role="tab" aria-controls="v-pills-point"
              aria-selected="true">
              <img src="../../assets/image/recursos/sistema-1.png" class="img-fluid" alt="">
            </a>
            <a class="nav-link" id="v-pills-inventory-tab p-2" data-bs-toggle="pill" data-bs-target="#v-pills-inventory"
              type="button" role="tab" aria-controls="v-pills-profile" aria-selected="false">
              <img src="../../assets/image/recursos/sistema-2.png" class="img-fluid" alt="">
            </a>
            <a class="nav-link" id="v-pills-webs-tab p-2" data-bs-toggle="pill" data-bs-target="#v-pills-webs"
              type="button" role="tab" aria-controls="v-pills-webs" aria-selected="false">
              <img src="../../assets/image/recursos/sistema-3.png" class="img-fluid" alt="">
            </a>
            <a class="nav-link" id="v-pills-facts-tab p-2" data-bs-toggle="pill" data-bs-target="#v-pills-facts"
              type="button" role="tab" aria-controls="v-pills-settings" aria-selected="false">
              <img src="../../assets/image/recursos/sistema-4.png" class="img-fluid" alt="">
            </a>
            <a class="nav-link" id="v-pills-reports-tab p-2" data-bs-toggle="pill" data-bs-target="#v-pills-reports"
              type="button" role="tab" aria-controls="v-pills-settings" aria-selected="false">
              <img src="../../assets/image/recursos/sistema-5.png" class="img-fluid" alt="">
            </a>
          </div>
          <div class="tab-content container bg-white bord m-0" id="v-pills-tabContent">
            <div class="tab-pane fade show active" id="v-pills-point" role="tabpanel"
              aria-labelledby="v-pills-point-tab">
              <div class="text-center p-0 p-sm-5">
                <h2 class="fw-bold title text-rojo">VENTAS Y COMERCIO</h2>
                <div class="container">
                  <div class="row mx-0">
                    <div class="col-lg-6 col-md-12">
                      <div class="px-md-0 px-1">
                        <div class="d-flex align-items-center ico panel">
                          <div class="flex-shrink-0 px-2 py-3 text-center logo me-2">
                            <img src="../../assets/image/recursos/icono-1.png" class="img-fluid" alt="...">
                          </div>
                          <div class="flex-grow-1 px-1 ms-0 text-start">
                            <p class="subtitle text-rojo my-0 mt-2 mb-1 lh-sm">Facturas y boletas</p>
                            <p class="mnt-1 text fw-bold lh-1"><small>Genera tus facturas y boletas de formaa
                                facil.</small></p>
                          </div>
                        </div>
                        <div class="d-flex align-items-center panel ico mt-2">
                          <div class="flex-shrink-0 px-2 py-3 text-center logo me-2">
                            <img src="../../assets/image/recursos/icono-2.png" class="img-fluid" alt="...">
                          </div>
                          <div class="flex-grow-1 px-1 ms-0 text-start">
                            <p class="subtitle fw-bold text-rojo mb-1 mt-1 lh-sm">Notas de crédito y débito.</p>
                            <p class="mnt-1 text fw-bold lh-1"><small>Has un reajuste en tus facturas o boletas, por
                                anulación completa o anulación parcial.</small></p>
                          </div>
                        </div>
                        <div class="d-flex align-items-center panel ico mt-2">
                          <div class="flex-shrink-0 px-2 py-3 text-center logo me-2">
                            <img src="../../assets/image/recursos/icono-3.png" class="img-fluid" alt="...">
                          </div>
                          <div class="flex-grow-1 px-1 ms-0 text-start">
                            <p class="subtitle fw-bold text-rojo mb-1 mt-1 lh-sm">Cotizaciones y Ordenes de crédito</p>
                            <p class="mnt-1 text fw-bold lh-1"><small>Genera tus cotizaciones y órdenes de compra con un
                                formato y estilo personalizado.</small></p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6 col-md-12">
                      <div class="px-md-0 px-1">
                        <div class="d-flex align-items-center panel ico">
                          <div class="flex-shrink-0 px-2 py-3 text-center logo me-2">
                            <img src="../../assets/image/recursos/icono-4.png" class="img-fluid" alt="...">
                          </div>
                          <div class="flex-grow-1 px-1 ms-0 text-start">
                            <p class="subtitle text-rojo my-0 lh-sm mt-2 mb-1 lh-sm">Personalización de comprobantes.
                            </p>
                            <p class="mnt-1 lh-1 text fw-bold"><small>Personaliza el formato y estilo de tus
                                comprobantes. Pon tu logo e información adicional para tus clientes.</small></p>
                          </div>
                        </div>
                        <div class="d-flex align-items-center panel ico mt-2">
                          <div class="flex-shrink-0 px-2 py-3 text-center logo me-2">
                            <img src="../../assets/image/recursos/icono-5.png" class="img-fluid" alt="...">
                          </div>
                          <div class="flex-grow-1 px-1 ms-0 text-start">
                            <p class="subtitle fw-bold text-rojo mb-1 mt-1 lh-sm">Puntos de venta.</p>
                            <p class="mnt-1 text fw-bold lh-1"><small>Cuenta con diferentes puntos de venta, con soporte
                                para lectura de códigos de barra, para pantallas táctiles, dispositivos móviles,
                                etc.</small></p>
                          </div>
                        </div>
                        <div class="d-flex align-items-center panel mt-2 ico">
                          <div class="flex-shrink-0 px-2 py-3 text-center logo me-2">
                            <img src="../../assets/image/recursos/icono-6.png" class="img-fluid" alt="...">
                          </div>
                          <div class="flex-grow-1 px-1 ms-0 text-start">
                            <p class="subtitle fw-bold text-rojo mb-1 mt-1 lh-sm">Apertura, cierre y Aqueo de caja.</p>
                            <p class="mnt-1 text fw-bold lh-1"><small>Controla tus ventas y flujo de dinero, (aperturas
                                y cierres de caja), reportes diarios, semanales y mensuales.</small></p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="w-100 mt-3">
                      <div class="row d-flex align-items-center">
                        <div class="col-lg-8 offset-lg-2 col-md-6 offset-md-3 col-12 text-center">
                          <img src="../../assets/image/servicios/facturacion.png" class="img-fluid" alt="">
                        </div>
                        <!-- <div class="col-lg-5 col-md-6 col-12">
                          <h3 class="text-center fw-bold mb-0 subtitle text-rojo">Galileo-ERP</h3>
                          <p class="text-md-start text-justify lh-sm text"><small>Este moderno software para
                              restaurantes propone una
                              solución global, escalable y adaptada a tu negocio. Galileo-ERP cubre todas las
                              necesidades del restaurante, mejora la eficiencia, optimiza los recursos e incrementa los
                              beneficios de la empresa.</small></p>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="v-pills-inventory" role="tabpanel" aria-labelledby="v-pills-inventory-tab">
              <div class="text-center p-5">
                <h2 class="fw-bold title text-lago">GESTIÓN DE INVENTARIO</h2>
                <p class="text-start text-marron lh-sm fw-bold text">Registra productos y sus características, tendrás
                  información del stock en tiempo real, podrás registrar compras, realizar transferencias entre
                  almacenes/sucursales, revisar tus kardex y valorización.</p>
                <img src="../../assets/image/galeria/inventario.png" class="img-fluid" style="max-height: 650px;"
                  alt="">
              </div>
            </div>
            <div class="tab-pane fade" id="v-pills-webs" role="tabpanel" aria-labelledby="v-pills-webs-tab">
              <div class="text-center p-5">
                <h2 class="fw-bold title text-lago">CONEXIÓN WEB</h2>
                <p class="text-start text-marron lh-sm fw-bold text">Nuestro sistema puede conectarse con tu pagina web
                  y mediante la pasarela de pagos te permite vender tus productos online a cualquier hora.</p>
                <img src="../../assets/image/galeria/web.png" class="img-fluid" style="max-height: 650px;" alt="">
              </div>
            </div>
            <div class="tab-pane fade" id="v-pills-facts" role="tabpanel" aria-labelledby="v-pills-facts-tab">
              <div class="text-center p-5">
                <h2 class="fw-bold title text-lago">FACTURACIÓN ELECTRONICA</h2>
                <p class="text-start text-marron lh-sm fw-bold text">El sistema cuenta con todas las certificaciones y
                  autorizaciones por parte de "SUNAT" para ayudarte a emitir y declarar cualquier tipo de comprobante
                  electrónico.</p>
                <img src="../../assets/image/galeria/fact.png" class="img-fluid" style="max-height: 650px;" alt="">
              </div>
            </div>
            <div class="tab-pane fade" id="v-pills-reports" role="tabpanel" aria-labelledby="v-pills-reports-tab">
              <div class="text-center p-5">
                <h2 class="fw-bold title text-lago">REPORTES INTELIGENTE</h2>
                <p class="text-start text-marron lh-sm fw-bold text">Podrás visualizar cuanto vendes , productos que más
                  vendes, obtén acceso directo a la información clave con los reportes inteligentes para una mejor toma
                  de decisiones, hazlo desde cualquier lugar.</p>
                <img src="../../assets/image/galeria/report.png" class="img-fluid" style="max-height: 650px;" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <svg class="separator" width="100%" height="120" viewBox="0.1 0.1 180 40" preserveAspectRatio="none"
    style="background-color: #88c0a8;">
    <g transform="translate(-18.298844,-77.973964)">
      <path style="fill:#AD3335;"
        d="M 31.615583,86.351641 H 192.16499 v 26.901969 c 0,0 -32.03411,-14.237983 -59.62682,-12.72484 -22.34188,1.2252 -54.779359,9.72634 -54.779359,9.72634 0,0 -22.029534,3.62882 -34.471238,-1.88988 -12.441702,-5.51871 -11.67199,-22.013589 -11.67199,-22.013589 z" />
      <path style="fill:#E0DCE4;"
        d="M 18.441597,78.106256 H 198.58126 v 39.288614 c 0,0 -43.10672,-27.825245 -73.47599,-19.687823 -30.369264,8.137423 -46.832208,12.548653 -46.832208,12.548653 0,0 -32.775418,8.05972 -46.735258,0 C 17.577964,102.19598 18.441597,78.106256 18.441597,78.106256 Z" />
    </g>
  </svg>
</section>
<section class="container-fluid py-5" style="background-color: #88c0a8;">
  <div class="container text-center py-5 box-2">
    <h2 class="fw-bold text-lago title fs-1">SOPORTE TÉCNICO</h2>
    <div class="row my-5">
      <div class="col-md-10 offset-md-1 order-1 col-12">
        <div class="row d-flex align-items-center px-5">
          <div class="col-md-4 order-1 order-md-2 col-12 text-center">
            <img src="../../assets/image/recursos/soporte.png" class="img-fluid mb-2" alt="">
            <h5 class="subtitle bg-title mx-auto fw-bold">SOPORTE CONTINUO</h5>
          </div>
          <div class="col-md-8 order-2 order-md-1 col-12 text-start">
            <p class="fw-bold subtitle text-lago"><u>Equipo de atención al cliente disponible los 7 Dias de la
                semana.</u>
            </p>
            <ul class="lista text mt-1 text-lago fw-bold text-justify">
              <li class="lh-sm">Reparaciones de averías, errores, problemas técnicos relacionados al uso del software.
              </li>
              <li class="lh-sm">Soporte telefónico: Servicio de asistencia telefónica para solución de dudas, consultas,
                asesoramiento
                y/o notificación de problemas sobre cualquier aspecto del Software.</li>
              <li class="lh-sm text-justify">Ayuda on-line: Servicio de asistencia telemática a través de correo
                electrónico, SMS, chat OnLine, Whatsap, para solución de dudas, consultas, asesoramiento y/o
                notificación de problemas sobre cualquier aspecto del Software.</li>
              <li class="lh-sm text-justify">Conexión remota: Servicio de asistencia telemático a través de conexión
                remota segura para solución de consultas, asesoramiento, resolución de problemas y/o notificación de
                problemas relacionados con el Software.</li>
            </ul>
          </div>
          <div class="w-100 my-3 order-3"></div>
          <div class="col-md-8 order-5 order-md-5 text-start">
            <p class="fw-bold subtitle text-lago"><u>Nuevas funcionalidades y mejoras continuas incluidas en tu plan sin
                cargo adicional.</u></p>
            <ul class="lista text mt-1 fw-bold text-lago">
              <li>Elaboración de actualizaciones o mejoras de acuerdo al requerimiento de nuestros clientes.</li>
              <li>Reparaciones de averías, errores, problemas técnicos relacionados al uso del software.</li>
              <li>Notificación apropiada a los usuarios para todos los mantenimientos planeados 24 horas antes de llevarse a cabo la interrupción del servicio.</li>
              <li>Sistema adaptándose continuamente al usuario.</li>
            </ul>
          </div>
          <div class="col-md-4 order-4 order-md-4 text-center">
            <img src="../../assets/image/recursos/actulizacion.png" class="img-fluid mb-2" alt="">
            <h5 class="subtitle bg-title mx-auto fw-bold">ACTUALIZACIONES SIN COSTO</h5>
          </div>
          <div class="w-100 my-3"></div>
          <div class="col-md-4 col-12 order-6 order-md-6 text-center">
            <img src="../../assets/image/recursos/capacitacion.png" class="img-fluid mb-2" alt="">
            <h5 class="subtitle bg-title mx-auto fw-bold">CAPACITACIÓN TOTAL</h5>
          </div>
          <div class="col-md-8 col-12 order-7 order-md-7 text-start">
            <p class="fw-bold subtitle text-lago"><u>Capacitación gratuita al personal de la empresa en el uso del
                software todo el tiempo del servicio</u></p>
            <ul class="lista text mt-1 fw-bold text-lago">
              <li>Sesiones presenciales o virtuales de capacitación del software ERP al personal idóneo de la empresa.
              </li>
              <li>Material en video y manuales de funcionamiento del software.</li>
              <li>Asistencia en la instalación y configuración del sistema para su empresa.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<svg class="separator" width="100%" height="120" viewBox="0.1 0.1 180 40" preserveAspectRatio="none">
  <g transform="translate(-18.298844,-77.973964)">
    <path style="fill:#AD3335;"
      d="M 31.615583,86.351641 H 192.16499 v 26.901969 c 0,0 -32.03411,-14.237983 -59.62682,-12.72484 -22.34188,1.2252 -54.779359,9.72634 -54.779359,9.72634 0,0 -22.029534,3.62882 -34.471238,-1.88988 -12.441702,-5.51871 -11.67199,-22.013589 -11.67199,-22.013589 z" />
    <path style="fill:#88c0a8;"
      d="M 18.441597,78.106256 H 198.58126 v 39.288614 c 0,0 -43.10672,-27.825245 -73.47599,-19.687823 -30.369264,8.137423 -46.832208,12.548653 -46.832208,12.548653 0,0 -32.775418,8.05972 -46.735258,0 C 17.577964,102.19598 18.441597,78.106256 18.441597,78.106256 Z" />
  </g>
</svg>
<section class="py-5 container-fluid px-0">
  <div class="w-100 my-5">
    <div class="row d-flex align-items-stretch mx-0">
      <div class="order-2 order-md-1 col-lg-4 col-md-6 col-12 p-5 bg-lago d-flex align-items-center">
        <div class="container p-1 p-md-5">
          <div class="px-3 py-md-5 py-1">
            <h2 class="title text-center fw-bold text-rojo">Nuestros Clientes</h2>
            <p class="text text-justify fw-bold text-white lh-sm">Contamos con mas de 3 años de experiencia ofreciendo
              sistemas de facturación,
              electronica y desarrollo de software en general, actualmente contamos con una cartera de mas de 200
              clientes
              atendidos en la ciudad de Cusco, Puno, Abancay y Lima</p>
          </div>
        </div>
      </div>
      <div class="order-1 order-md-2 col-lg-8 col-md-6 col-12 bg-white py-5">
        <div class="container text-center">
          <img class="img-clientes" src="../../assets/image/empresas/1.png" width="100" />
          <img class="img-clientes" src="../../assets/image/empresas/2.png" width="100" />
          <img class="img-clientes" src="../../assets/image/empresas/3.png" width="100" />
          <img class="img-clientes" src="../../assets/image/empresas/4.png" width="100" />
          <img class="img-clientes" src="../../assets/image/empresas/5.png" width="100" />
          <img class="img-clientes" src="../../assets/image/empresas/6.png" width="100" />
          <img class="img-clientes" src="../../assets/image/empresas/7.png" width="100" />
          <img class="img-clientes" src="../../assets/image/empresas/8.png" width="100" />
          <img class="img-clientes" src="../../assets/image/empresas/9.png" width="100" />
          <img class="img-clientes" src="../../assets/image/empresas/10.png" width="100" />
          <img class="img-clientes" src="../../assets/image/empresas/11.png" width="100" />
          <img class="img-clientes" src="../../assets/image/empresas/12.png" width="100" />
          <img class="img-clientes" src="../../assets/image/empresas/13.png" width="100" />
          <img class="img-clientes" src="../../assets/image/empresas/14.png" width="100" />
          <img class="img-clientes" src="../../assets/image/empresas/15.png" width="100" />
          <img class="img-clientes" src="../../assets/image/empresas/16.png" width="100" />
          <img class="img-clientes" src="../../assets/image/empresas/17.png" width="100" />
          <img class="img-clientes" src="../../assets/image/empresas/18.png" width="100" />
          <img class="img-clientes" src="../../assets/image/empresas/19.png" width="100" />
          <img class="img-clientes" src="../../assets/image/empresas/20.png" width="100" />
          <img class="img-clientes" src="../../assets/image/empresas/21.png" width="100" />
          <img class="img-clientes" src="../../assets/image/empresas/22.png" width="100" />
          <img class="img-clientes" src="../../assets/image/empresas/23.png" width="100" />
          <img class="img-clientes" src="../../assets/image/empresas/24.png" width="100" />
        </div>
      </div>
    </div>
  </div>
  <div class="w-100 my-5"></div>
  <div class="col-lg-4 col-md-6 col-12 mx-auto mb-4">
    <div class="container text-center">
      <h2 class="title fw-bold text-lago">Garantía de Servicio y Base Legal</h2>
    </div>
  </div>
  <div id="flex-container" class="testimonials">
    <div id="left-zone">
      <ul class="list">
        <li class="item">
          <input type="radio" id="radio_testimonial-1" name="basic_carousel" checked="checked" />
          <label class="label_testimonial-1" for="radio_testimonial-1">Galileo ERP</label>
          <div class="content-test content_testimonial-1">
            <span class="picto"></span>
            <h1>Software Electrónico</h1>
            <p class="text lh-sm"><small>Nuestro principal producto “Galileo-ERP”, permite emitir comprobantes electrónicos, realizar tareas de ventas, gestión de inventarios, administración de clientes, de proveedores, de productos, de servicios, de cuentas por cobrar y pagar, entre otros, lo que ha permitido a nuestra amplia cartera de clientes simplificar y optimizar sus procesos.</small></p>
            <p class="testimonialFrom fw-bold">YACHAY</p>
            <!-- <p class="testimonialState">Rochester, NY</p> -->
          </div>
        </li>
        <li class="item">
          <input type="radio" id="radio_testimonial-2" name="basic_carousel" />
          <label class="label_testimonial-2" for="radio_testimonial-2">Microsoft Azure</label>
          <div class="content-test content_testimonial-2">
            <span class="picto"></span>
            <h1 class="title">Microsoft Azure</h1>
            <p class="text lh-sm"><small>Todos tus comprobantes son almacenados en la Nuve de Microsoft Azure ,la cual
                brinda el servicio de respaldos automáticos diarios y replicación geográfica de datos.Su información
                esta asegurada.</small></p>
            <p class="testimonialFrom fw-bold">Microsoft</p>
            <!-- <p class="testimonialState">Tucson, AZ</p> -->
            <br>
          </div>
        </li>
        <li class="item">
          <input type="radio" id="radio_testimonial-3" name="basic_carousel" />
          <label class="label_testimonial-3" for="radio_testimonial-3">Comprobantes</label>
          <div class="content-test content_testimonial-3">
            <span class="picto"></span>
            <h1>Comprobante Electrónico</h1>
            <p class="text lh-sm"><small>Resolución Sunat 097/2012 - Aprueba el uso de emisión de comprobantes
                electrónicos, desde los sistemas del contribuyente permitiendo escoger la solución que mas se adapte a
                sus necesidades.</small></p>
            <p class="testimonialFrom">SUNAT</p>
            <!-- <p class="testimonialState">Monterey, CA</p> -->
          </div>
        </li>
        <li class="item">
          <input type="radio" id="radio_testimonial-4" name="basic_carousel" />
          <label class="label_testimonial-4" for="radio_testimonial-4">Nubefact</label>
          <div class="content-test content_testimonial-4">
            <span class="picto"></span>
            <h1>Servicios Electrónicos</h1>
            <p class="text lh-sm"><small>“Nubefact” es actualmente una de las OSE (operador de servicios electrónicos) reconocidos por Sunat, la cual asegura el cumplimiento de las condiciones técnicas de los comprobantes de pago electrónicos requeridas por SUNAT y autoriza la emisión mediante una constancia de recepción (CDR). Nuestro socio comercial validará todos sus comprobantes generados por nuestro sistema.</small></p>
            <p class="testimonialFrom">Yachay</p>
            <!-- <p class="testimonialState">Somerset, VA</p> -->
            <br>
          </div>
        </li>
      </ul>
    </div>
    <div id="right-zone"></div>
  </div>
  <div class="container mt-5">
    <div class="row d-flex align-items-center mx-0">
      <div class="col-lg-8 col-md-6 col-12 order-md-1 order-2 mx-auto my-5 my-sm-1">
        <div class="w-prueba text-center">
          <h2 class="title text-lago">SOLICITAR UNA DEMO GRATIS</h2>
          <p class="text-justify text fw-bold lh-sm">Estamos listos para ayudarte a decidir si nuestras soluciones se
            ajusten a los requerimientos que necesita tu negocio. Agenda una demostración de 30 minutos con nostros sin
            ningún compromiso. Gustosos te atenderemos</p>
          <a class="btn-demo subtitle mt-3"  [routerLink]="['/contacto']" role="button">Solicita una demo gratis</a>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-12 order-md-2 order-1 text-center">
        <div class="video-responsive container ms-2 mx-auto">
          <iframe width="auto" height="100%" src="../../assets/video/yachay.mp4" title="Yachay" frameborder="0"
            allow="autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">
          </iframe>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- <svg class="separator" width="100%" height="120" viewBox="0.1 0.1 180 40" preserveAspectRatio="none">
  <g transform="translate(-18.298844,-77.973964)">
    <path style="fill:#AD3335;"
      d="M 31.615583,86.351641 H 192.16499 v 26.901969 c 0,0 -32.03411,-14.237983 -59.62682,-12.72484 -22.34188,1.2252 -54.779359,9.72634 -54.779359,9.72634 0,0 -22.029534,3.62882 -34.471238,-1.88988 -12.441702,-5.51871 -11.67199,-22.013589 -11.67199,-22.013589 z" />
    <path style="fill:#88c0a8;"
      d="M 18.441597,78.106256 H 198.58126 v 39.288614 c 0,0 -43.10672,-27.825245 -73.47599,-19.687823 -30.369264,8.137423 -46.832208,12.548653 -46.832208,12.548653 0,0 -32.775418,8.05972 -46.735258,0 C 17.577964,102.19598 18.441597,78.106256 18.441597,78.106256 Z" />
  </g>
</svg> -->
<section class="section-bubble5">
  <footer-web></footer-web>
</section>
